import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ViCareChangeLog } from '../../@store/updates/changelog.model';

@Component({
  selector: 'app-vicare-update',
  templateUrl: './vicare-update.component.html',
  styleUrls: ['./vicare-update.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViCareUpdateComponent {
  @Input() update: ViCareChangeLog;
}
